import auth0Client from "app/auth/Auth";
import { useQuery } from "react-query";
import findManagerPermissions from "v2/domain/common/useCases/findManagerPermissions/findManagerPermissions";

const useFindManagerPermissions = () => {
  const companyId = auth0Client.getCompanyId();
  return useQuery(["manager-permissions", companyId], () =>
    findManagerPermissions()
  );
};

export default useFindManagerPermissions;
